import { storage } from "@/lib/firebase/clientApp";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { useUploadProgress } from "@/stores/progress";

export const STORAGE_UPLOADS_PATH = process.env.NEXT_PUBLIC_FIREBASE_STORAGE_UPLOADS_PATH!;

export function uploadToStorage(file: File, uuid: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, `${STORAGE_UPLOADS_PATH}/${uuid}`);
    const task = uploadBytesResumable(storageRef, file);
    const { setProgress, clearProgress } = useUploadProgress.getState();

    setProgress(uuid, 0);

    task.on(
      "state_changed",
      (s) => {
        const progress = (s.bytesTransferred / s.totalBytes) * 100;
        setProgress(uuid, progress); // zustand에 반영
      },
      (err) => {
        clearProgress(uuid);
        reject(err);
      },
      async () => {
        setProgress(uuid, 100);
        const url = await getDownloadURL(task.snapshot.ref);
        // 업로드 완료 후 필요시 제거
        setTimeout(() => clearProgress(uuid), 2000);
        resolve(url);
      }
    );
  });
}

export function getFileUrl(fileUuid: string): Promise<string> {
  return new Promise(async (resolve, reject) => {
    try {
      const storageRef = ref(storage, `${STORAGE_UPLOADS_PATH}/${fileUuid}`);
      const url = await getDownloadURL(storageRef);
      resolve(url);
    } catch (error) {
      reject(error);
    }
  });
}

export function getResultThumbnailUrl(thumbnailFilename: string): Promise<string> {
  return new Promise(async (resolve, reject) => {
    try {
      const storageRef = ref(storage, `job/thumbnails/${thumbnailFilename}`);
      const url = await getDownloadURL(storageRef);
      resolve(url);
    } catch (error) {
      reject(error);
    }
  });
}

export function getResultFileUrl(filename: string): Promise<string> {
  return new Promise(async (resolve, reject) => {
    try {
      const storageRef = ref(storage, `job/results/${filename}`);
      const url = await getDownloadURL(storageRef);
      resolve(url);
    } catch (error) {
      reject(error);
    }
  });
}

export function deleteFile(path: string): Promise<boolean> {
  return new Promise(async (resolve, reject) => {
    try {
      const storageRef = ref(storage, path);
      await deleteObject(storageRef);
      resolve(true);
    } catch (error) {
      // 파일이 없는 경우도 성공으로 처리하지만, 삭제된 것은 아니므로 false 반환
      if ((error as any).code === "storage/object-not-found") {
        resolve(false);
      } else {
        reject(error);
      }
    }
  });
}
